module.exports = __webpack_public_path__ + "img/explain_1.16b05955.png";